document.addEventListener('DOMContentLoaded', function () {
  let isLoading = false;
  let nextPageUrl = document.querySelector('.pagination__next')?.getAttribute('href');

  function loadMoreProducts() {
    if (isLoading || !nextPageUrl) return;

    isLoading = true;

    fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Append new products to the product grid
        const newProducts = doc.querySelectorAll('.grid__item');
        const productGrid = document.querySelector('.product-grid');
        newProducts.forEach(product => {
          productGrid.appendChild(product);
        });

        // Update the nextPageUrl
        const nextPagination = doc.querySelector('.pagination__next');
        nextPageUrl = nextPagination ? nextPagination.getAttribute('href') : null;

        isLoading = false;
      })
      .catch(error => {
        console.error('Error loading more products:', error);
        isLoading = false;
      });
  }

  // Detect when the user scrolls near the bottom of the page
  window.addEventListener('scroll', function () {
    const scrollPosition = window.scrollY + window.innerHeight;
    const threshold = document.body.offsetHeight - 300;

    if (scrollPosition > threshold) {
      loadMoreProducts();
    }
  });
});
